import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { HomePage } from '../../../pages/HomePage';
import { WorkoutsLibrary } from '../../workouts/WorkoutsLibrary';
import { PlanPage } from '../../../pages/PlanPage';
import { ClubPage } from '../../../pages/ClubPage';
import { NutritionPage } from '../../../pages/NutritionPage';
import { ShopPage } from '../../../pages/ShopPage';
import { JournalPage } from '../../../pages/JournalPage';
import { PeriodTrackerPage } from '../../../pages/PeriodTrackerPage';
import { CompanionPage } from '../../../pages/CompanionPage';
import { MindfulnessPage } from '../../../pages/MindfulnessPage';
import { HealthMonitorPage } from '../../health/HealthMonitorPage';
import { StressMonitor } from '../../stress/StressMonitor';
import { RecoveryPage } from '../../../pages/RecoveryPage';
import { StrainPage } from '../../../pages/StrainPage';
import { SleepPage } from '../../../pages/SleepPage';
import { HrvPage } from '../../../pages/HrvPage';

export function ClientRoutes() {
  return (
    <Routes>
      <Route path="/home" element={<HomePage />} />
      <Route path="/workouts" element={<WorkoutsLibrary onClose={() => null} />} />
      <Route path="/mindfulness" element={<MindfulnessPage />} />
      <Route path="/plan" element={<PlanPage />} />
      <Route path="/club" element={<ClubPage />} />
      <Route path="/nutrition" element={<NutritionPage />} />
      <Route path="/shop" element={<ShopPage />} />
      <Route path="/journal" element={<JournalPage />} />
      <Route path="/cycle" element={<PeriodTrackerPage />} />
      <Route path="/companion" element={<CompanionPage />} />
      <Route path="/vitals" element={<HealthMonitorPage />} />
      <Route path="/calm-monitor" element={<StressMonitor />} />
      <Route path="/recovery" element={<RecoveryPage />} />
      <Route path="/strain" element={<StrainPage />} />
      <Route path="/sleep" element={<SleepPage />} />
      <Route path="/hrv" element={<HrvPage />} />
      <Route path="*" element={<Navigate to="/home" replace />} />
    </Routes>
  );
}